import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

/**
 * Back arrow + label, rendered above page titles. Returns to the previous
 * page; direct-link entries (no history) fall back to the frontpage.
 */
export function BackButton({ label = 'back' }: { label?: string }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => {
        if (window.history.length > 1) navigate(-1);
        else navigate('/');
      }}
      className="inline-flex items-center gap-1 mb-2 text-[12px] text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200"
    >
      <ArrowLeft className="size-3.5" />
      {label}
    </button>
  );
}
